export default {
  有效交易量达标即可获得:`報酬を獲得する前提は最低取引量を満たす必要があります。詳細は<a href="#pay-session5">注意事項</a>をご覧ください。`,
  交易领薪计划: "シグナル報酬プログラム",
  为了鼓励交易者提升交易水平:` 取引能力を磨いて年率最大<span class="red">18<span class="sRed">%</span></span>の管理報酬を得ましょう。`,
  加入交易社区: "",
  即刻发起交易信号: "取引シグナルを公開",
  无限奖励月月拿: "無上限の月間報酬",
  优享11个专属大礼: "11種類の特典",
  即刻加入: "今すぐ参加",
  交易员等级奖励机制: `プログラム詳細`,
  EBC基于跟随人数和资金提供五档奖励:
    "報酬は取引回数の制限や損益にかかわらず、フォロワー数と運用資産に基づいて5段階に分かれています。",
  "/月": "/月",
  初級トレーダー: "初級トレーダー",
  管理资金量: "運用資産（AUM）",
  跟随账户数: "フォロワー数",
  大师交易员: "中級トレーダー",
  冠军交易员: "上級トレーダー",
  明星交易员: "スタートレーダー",
  资金管理费: "+1％の管理料",
  传奇交易员: "レジェンドトレーダー",
  多层次的增值服务: "各段階別サービス",
  EBC提供多达11项增值服务:
    "本プログラムでは11種類の特典を提供し、シグナルの宣伝に協力します。",
  "精英/大师交易员": "初級/中級",

  "7×24小时优先客服": "24時間日本語サポート",
  金融投资经典书籍礼遇: "投資関連書籍の無料進呈",
  专属VPS赞助: "専用VPSスポンサーシップ",
  订单流软件1年使用权: "オーダーフロー分析ツールへの無料アクセス（1年間）",
  EBC定制大礼包: "EBC オリジナルギフト",
  信号优先置顶展示: "シグナル優先表示",
  受邀参观海外办公室: "海外オフィス訪問",
  巴萨球星联名礼包: "FCバルセロナギフトセット",
  巴萨赛场传奇之旅: "バルサ観戦へ招待",
  品牌战略合作: "戦略的ブランドパートナーシップ",
  全球金融资源管家服务: "グローバル資産管理サービス",
  五维指标评价系统: "5次元データ分析モデル",
  为交易员信号提供公开透明的评估:
    "トレーダーのシグナルに対して明瞭かつ透明性のある評価を行い、トレーディングスタイルを明らかにすることで、より多くのフォロワーを集めます。",
  收益率: "収益率",
  历史收益率:
    "現時点までの投資リターンを指します。数値が高いほど優れています。",
  最大回撤: "最大ドローダウン",
  衡量风控能力:
    "シグナルのリスク管理能力を示す指標で、低いほどリスクが低いことを意味します。",
  获利系数: "リカバリーファクター",
  利润因子:
    "ドローダウンからどれだけ早く回復しているかを示す指標です。数値が高ければ回復力が強く、1より低い場合は、まだ元の資金水準には回復していないことを表します。",
  夏普比率: "シャープレシオ",
  每份风险的收益:
    "リスクとリターンの関係を測る指標で、同じリスクで得られる超過リターンを比較するのに役立ちます。",
  标准差: "標準偏差",
  收益波动率:
    "収益のボラティリティを表します。低いほど、安定した利益率と、低リスクであることを示します。",
  以上数据仅供参考: "*上記のデータは参考のみです。",
  活动须知: "注意事項",
  list: [
    {
      label: "1.フォロワーについて",
      value: [
        {label:'フォロワー資金額＝取引口座残高÷フォローしているシグナル数',value:[]},
        {label:'フォロー制限：各取引口座は同時に最大10シグナルをフォローできます。',value:[]},
        {label:'フォロワー数：フォロワー資金額が500米ドル以上の口座が有効フォロワー数としてカウントされます。500米ドル未満の口座はフォロワー資金額及び有効なフォロワー口座数とはみなされません。​',value:[]},
        {label:'※同じEBCアカウント下にある複数の取引口座が同じシグナルをフォローしている場合、1フォロワーとしてカウントされます。',value:[]},
        {label:'運用資産（AUM）＝フォロワー資金額合計＋シグナル口座残高',value:[]},
        // {label:'自己フォロー：自身のシグナルを同一アカウント下の取引口座でフォローしている場合、有効なフォロワー数及び運用資産（AUM）としてカウントされません。',value:[]}
      ],
    },
    {
      label: "2. レベルの評価と報酬基準",
      value: [
        {label:'レベルの評価：レベルは1時間ごとに自動的にシステムによって評価されます。運用資産（AUM）と有効フォロワー数の両方が特定のレベルの要件を満たしている場合、そのレベルは有効とみなされます。',value:[]},
        {label:'報酬基準（下記すべての条件を満たす必要があります）:',
          value:['シグナル口座は歴月のすべての日において最低基準のレベルを達成すると、報酬が基準を満たした最低レベルに基づいて計算されます。',
            {innerLabel:"月間最低取引量はシグナル口座の日次平均残高の0.2%ロット以上である必要があります。例：残高1,000ドルの場合、月間は最低2Lot以上取引する必要があります。",innerValue:['月間最低取引量＝月間合計決済取引量＋ネットオープンポジション（ネットオープンポジション＝合計オープン取引量ー同ー銘柄のヘッジポジション）',
            '日次平均残高＝シグナル口座の日次残高の合計÷月の暦日数',
            '米国株およびETFは最低取引量の計算対象外です。']}
            ]},
        {label:'報酬の計算と付与',value:['日次平均運用資産 = 日次運用資産の合計÷月の暦日数','月間報酬＝（日次平均運用資産×年間管理報酬率）÷12','毎月末を締め日とし、翌月の第一週に前月の報酬を計算して、審査完了後にシグナル口座に直接付与します。付与口座を変更されたい場合は、カスタマーサポートまでご連絡ください。','本イベントは、認証済みの有効顧客のみ対象となります。規約および有効顧客の定義に関する最終的な解釈権はEBCに帰属します。']}
      ],
    }
  ],
  年化资金管理费: "年間管理報酬",
};
